import { render } from "./PanelSettingsEditor.vue?vue&type=template&id=0e50212d&scoped=true&ts=true"
import script from "./PanelSettingsEditor.vue?vue&type=script&lang=ts"
export * from "./PanelSettingsEditor.vue?vue&type=script&lang=ts"

import "./PanelSettingsEditor.vue?vue&type=style&index=0&id=0e50212d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e50212d"]])

export default __exports__